import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { setApikey } from "../redux/slices/apikeySlice";
import axios from 'axios';
import { setCurrentApikey } from '../redux/slices/currentApikeySelectedSlice';
import MyApikeyForm from './MyApikeyForm';


function RegisterModalOptions() {
  const [inputValue, setInputValue] = useState('');
 
  const apikeysData = useSelector((state)=>state.apikey);
  
  const [selectedApiKey, setSelectedApiKey] = useState(null)
  
  const apiKeys = apikeysData?.apikey||[];
  
  const headers=((state)=>state.header);
  const dispatch = useDispatch();
  const api=localStorage.getItem('api'); 

  function fetchData() {
    const api = localStorage.getItem("api");
    axios
      .get(api + `/list/apikeys`, { headers: headers.headers })
      .then((response) => {
        
        dispatch(setApikey(response.data));
      })
      .catch((error) => {
        console.error(error);
      });
  }
  React.useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (event,newValue) => {
    setInputValue(newValue);
     const existingApiKey = apiKeys?.find((apiKey) => apiKey?.name === newValue);
    setSelectedApiKey(existingApiKey);
   dispatch(setCurrentApikey(existingApiKey?.key));
};


  
  return (
    <div >
      <Autocomplete
        value={inputValue}
        options={apiKeys?.map((apiKey) => apiKey?.name)} 
        onChange={handleInputChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label="API Key"
            variant="outlined"
            size="small"
           
            
          />
        )}
      />
       <div style={{ marginTop: '.75rem',width:"35ch" }}>
          <MyApikeyForm />
       </div>
   </div>
  );
}


export default RegisterModalOptions;
